import React  from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

function AddContract() {
  //   const [formData, setFormData] = useState();
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      customer: "",
      subject: "",
      contractValue: "",
      contractType: "",
      startDate: "",
      endDate: "",
      contractDescription: "",
      trash: false,
      hideCustomer: false,
    },
    validationSchema: Yup.object({
      customer: Yup.string().required("Please enter customer name"),
      subject: Yup.string().required("Please enter subject"),
      contractValue: Yup.string().required("Please enter contract value"),
      contractType: Yup.string().required("Please select contract type"),
      startDate: Yup.date().required("Please enter start date"),
      endDate: Yup.date(),
      contractDescription: Yup.string(),
      trash: Yup.boolean(),
      hideCustomer: Yup.boolean(),
    }),
    onSubmit: (values) => {
      // console.log(values);
      // You can handle form data here (e.g., save to state or send to server)
      navigate("/contracts/contracts");
    },
  });

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Row className="py-4">
          <Col>
            <Card>
              <CardBody>
                <h4 className="card-title text-primary">Add Contract</h4>
                <Form
                  className="row g-3 needs-validation py-4"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Row>
                      <Col md="2">
                        <FormGroup className="mb-3">
                          <Label check>
                            <Input
                              type="checkbox"
                              name="trash"
                              id="trash"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              checked={validation.values.trash}
                            />{" "}
                            Trash
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md="2">
                        <FormGroup className="mb-3">
                          <Label check>
                            <Input
                              type="checkbox"
                              name="hideCustomer"
                              id="hideCustomer"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              checked={validation.values.hideCustomer}
                            />{" "}
                            Hide Customer
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="customer">
                          Customer <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="customer"
                          placeholder=""
                          type="text"
                          className="form-control"
                          id="customer"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.customer || ""}
                          invalid={
                            validation.touched.customer &&
                            validation.errors.customer
                              ? true
                              : false
                          }
                        />
                        {validation.touched.customer &&
                        validation.errors.customer ? (
                          <FormFeedback type="invalid">
                            {validation.errors.customer}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="subject">
                          Subject <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="subject"
                          placeholder=""
                          type="text"
                          className="form-control"
                          id="subject"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subject || ""}
                          invalid={
                            validation.touched.subject &&
                            validation.errors.subject
                              ? true
                              : false
                          }
                        />
                        {validation.touched.subject &&
                        validation.errors.subject ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subject}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contractValue">
                          Contract Value <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="contractValue"
                          placeholder=""
                          type="text"
                          className="form-control"
                          id="contractValue"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contractValue || ""}
                          invalid={
                            validation.touched.contractValue &&
                            validation.errors.contractValue
                              ? true
                              : false
                          }
                        />
                        {validation.touched.contractValue &&
                        validation.errors.contractValue ? (
                          <FormFeedback type="invalid">
                            {validation.errors.contractValue}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contractType">
                          Contract Type <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="select"
                          id="contractType"
                          name="contractType"
                          className="form-select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contractType || ""}
                          invalid={
                            validation.touched.contractType &&
                            validation.errors.contractType
                              ? true
                              : false
                          }
                        >
                          <option value="">Select</option>
                          <option value="Managed services contract">
                            Managed services contract
                          </option>
                          <option value="Fixed price contract">
                            Fixed price contract
                          </option>
                          <option value="Block Time">Block Time</option>
                        </Input>
                        {validation.touched.contractType &&
                        validation.errors.contractType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.contractType}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="startDate">
                          Start Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="startDate"
                          placeholder=""
                          type="date"
                          className="form-control"
                          id="startDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.startDate || ""}
                          invalid={
                            validation.touched.startDate &&
                            validation.errors.startDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.startDate &&
                        validation.errors.startDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.startDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="endDate">End Date</Label>
                        <Input
                          name="endDate"
                          placeholder=""
                          type="date"
                          className="form-control"
                          id="endDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.endDate || ""}
                          invalid={
                            validation.touched.endDate &&
                            validation.errors.endDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.endDate &&
                        validation.errors.endDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.endDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contractDescription">
                          Contract Description
                        </Label>
                        <Input
                          name="contractDescription"
                          placeholder=""
                          type="text"
                          className="form-control"
                          id="contractDescription"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contractDescription || ""}
                          invalid={
                            validation.touched.contractDescription &&
                            validation.errors.contractDescription
                              ? true
                              : false
                          }
                        />
                        {validation.touched.contractDescription &&
                        validation.errors.contractDescription ? (
                          <FormFeedback type="invalid">
                            {validation.errors.contractDescription}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="col-12">
                    <button
                      className="btn w-md btn-primary float-end mx-3"
                      type="submit"
                    >
                      Save
                    </button>
                    <button
                      className="btn w-md btn-primary float-end"
                      type="button"
                      onClick={() => navigate("/contracts/contracts")}
                    >
                      Cancel
                    </button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AddContract;
